// Regras de UX para troca de contexto de navegacao (cliente / rede ativos).
// Fonte unica usada pelo badge do header e pelo TrocaContextoModal. E UX,
// nao seguranca: o backend (GET /auth/clientes-acessiveis + POST
// /auth/active-client) e quem garante o escopo.

interface UserVinculos {
  isAdmin?: boolean | null;
  clientUuid?: string | null;
  clientGroupId?: number | null;
  networkId?: number | null;
  networkGroupId?: number | null;
}

// Limite de itens que o backend devolve em /auth/clientes-acessiveis sem busca.
export const LIMITE_CLIENTES_ACESSIVEIS = 200;

// Perfil frotista: pode trocar de cliente quem e super admin, quem tem
// agrupamento de clientes (Cliente Master, com ou sem cliente proprio) ou
// quem enxerga mais de um cliente na lista acessivel.
export function podeTrocarCliente(user: UserVinculos, totalClientes: number): boolean {
  return !!user.isAdmin || !!user.clientGroupId || totalClientes > 1;
}

// Perfil posto: espelha a visibilidade de computeRedesAcessiveis no backend.
// Quem tem rede direta (networkId) so enxerga a propria; senao pode trocar
// quem e Rede Master ou super admin. Vinculo de cliente nao interfere (o
// admin global com cliente vinculado continua vendo todas as redes).
export function podeTrocarRede(user: UserVinculos): boolean {
  if (user.networkId) return false;
  return !!user.networkGroupId || !!user.isAdmin;
}

// Busca server-side de redes: admin enxerga todas as redes do sistema
// (lista sem busca vem truncada em 200).
export function usarBuscaServidorRedes(user: UserVinculos, totalRedes: number): boolean {
  return (!!user.isAdmin && !user.networkGroupId) || totalRedes >= LIMITE_CLIENTES_ACESSIVEIS;
}

// Busca server-side so quando a lista carregada pode estar truncada: admin
// enxerga todos os clientes do sistema; demais so se bateram no limite.
export function usarBuscaServidorClientes(user: UserVinculos, totalClientes: number): boolean {
  return !!user.isAdmin || totalClientes >= LIMITE_CLIENTES_ACESSIVEIS;
}
